import type { ReactNode } from "react";
import { Container } from "@circle-react/components/shared/Container";
import { useHomepageContext } from "./HomepageContext";

interface HomepageContentWrapperProps {
  children: ReactNode;
}

export const HomepageContentWrapper = ({
  children,
}: HomepageContentWrapperProps) => {
  const { hasSidebarContent } = useHomepageContext();
  const maxWidth = hasSidebarContent ? "lg" : "md";
  return <Container maxWidth={maxWidth}>{children}</Container>;
};
